// removed by extract-text-webpack-plugin
module.exports = {"main":"_3RLEO_afCdUVXRNQtBZ1ga","textCenter":"_1QqEn0pEUv9f664FEyHx44","backLink":"_2ios18guVHoBtd5iQqOCc","sheet":"kxnheg6QLTD6NDMXE0M6x","button":"_1F5GctzcTGVe6rBBN33Gji","relatedLinksHeading":"_2xZ_GcVLCWsD4X5PpxuANW","rightColumn":"_2yqkHgZZXGZJF32kG78taL","separator":"_2RaifHJ_OpRWrZ7uw0GG5a","feature":"_3w8-v6w6Vv-3tb7rQq2Tr8","featureHeading":"_1FHeE-3rOxsacXnmobhR3h","featureIcon":"_1XjD5pLHoqJby0G54CXyUe","sources":"_3WY63jFM5EFLUd5oJJjeA9","source":"_39sstqbuF0BA1xkLLP5vUo","methods":"gink026WOMpJZXezqgPx9","method":"_1uwEN8WWSmehKdNFUMXvae"};


//////////////////
// WEBPACK FOOTER
// ./components/IntegrationsCatalog/Detail.module.css
// module id = 2356
// module chunks = 1